__turbopack_context__.v({
  "archive-line-arrival": "collection-hall-module__7fN5WG__archive-line-arrival",
  "archiveLine": "collection-hall-module__7fN5WG__archiveLine",
  "collection": "collection-hall-module__7fN5WG__collection",
  "collectionHall": "collection-hall-module__7fN5WG__collectionHall",
  "collectionHeader": "collection-hall-module__7fN5WG__collectionHeader",
  "collectionNote": "collection-hall-module__7fN5WG__collectionNote",
  "completeIndex": "collection-hall-module__7fN5WG__completeIndex",
  "controls": "collection-hall-module__7fN5WG__controls",
  "emptyState": "collection-hall-module__7fN5WG__emptyState",
  "enterCue": "collection-hall-module__7fN5WG__enterCue",
  "facet": "collection-hall-module__7fN5WG__facet",
  "facets": "collection-hall-module__7fN5WG__facets",
  "poster": "collection-hall-module__7fN5WG__poster",
  "poster-resolve": "collection-hall-module__7fN5WG__poster-resolve",
  "posterCatalogue": "collection-hall-module__7fN5WG__posterCatalogue",
  "posterContent": "collection-hall-module__7fN5WG__posterContent",
  "posterCopy": "collection-hall-module__7fN5WG__posterCopy",
  "posterDuration": "collection-hall-module__7fN5WG__posterDuration",
  "posterFeatured": "collection-hall-module__7fN5WG__posterFeatured",
  "posterFoot": "collection-hall-module__7fN5WG__posterFoot",
  "posterImage": "collection-hall-module__7fN5WG__posterImage",
  "posterJourney": "collection-hall-module__7fN5WG__posterJourney",
  "posterLink": "collection-hall-module__7fN5WG__posterLink",
  "posterMapArt": "collection-hall-module__7fN5WG__posterMapArt",
  "posterRegular": "collection-hall-module__7fN5WG__posterRegular",
  "posterSubtitle": "collection-hall-module__7fN5WG__posterSubtitle",
  "posterTitle": "collection-hall-module__7fN5WG__posterTitle",
  "posterVeil": "collection-hall-module__7fN5WG__posterVeil",
  "printIndex": "collection-hall-module__7fN5WG__printIndex",
  "programmeWall": "collection-hall-module__7fN5WG__programmeWall",
  "resultCount": "collection-hall-module__7fN5WG__resultCount",
  "reveal": "collection-hall-module__7fN5WG__reveal",
  "searchField": "collection-hall-module__7fN5WG__searchField",
  "searchInputWrap": "collection-hall-module__7fN5WG__searchInputWrap",
  "srOnly": "collection-hall-module__7fN5WG__srOnly",
  "threshold": "collection-hall-module__7fN5WG__threshold",
  "thresholdCopy": "collection-hall-module__7fN5WG__thresholdCopy",
  "thresholdFoot": "collection-hall-module__7fN5WG__thresholdFoot",
  "thresholdIndex": "collection-hall-module__7fN5WG__thresholdIndex",
  "utilityLabel": "collection-hall-module__7fN5WG__utilityLabel",
  "wingFilters": "collection-hall-module__7fN5WG__wingFilters",
});
